import { VALID_TEST_ID } from '@helpers/constants/automated-tests/valid-test-id';
import { clientLogger } from '@services/logger/clientLogger';
import { TContext, TElement, TRole } from 'types/context-role-element.types';

export const getTestId = (context: TContext, role: TRole, element: TElement) => {
  const testIdIsValid = VALID_TEST_ID[context]?.[role]?.includes(element);

  if (testIdIsValid === undefined) {
    clientLogger.ERROR({
      message: 'Erro ao inserir o TestID - TestID não existente',
      context: { context, role, element },
    });
    return undefined;
  }

  if (!testIdIsValid) {
    clientLogger.ERROR({
      message: 'Erro ao inserir o TestID - TestID inválido',
      context: { context, role, element },
    });
    return null;
  }

  return `${context}-${role}-${element}`;
};
